import { default as app, collapsibleHeaderClickEvent, onWindowResize, resetSelectionColumn, ToggleYellowToGreen, ToggleGreenToYellow, IsUndefinedOrNull } from '@legacy/App';

app.factory('SalestaxFactory', ['$http', 'settings', function ($http, settings) {
    var url = settings.ApiURL + settings.BankAccountURL;

    return {
        getBankAccountList: function () {
            return $http.get(url);
        }
    };
}]);

app.controller('SalestaxController', ['$scope', 'SalestaxFactory', function ($scope, SalestaxFactory) {

    
    

    $scope.getProductList = function () {
        SalestaxFactory.getBankAccountList().success(function (data) {
            $scope.bankAccounts = data;
            $scope.refreshGrid();
        }).error(function (data) {
            $scope.error = data;
        });
    };

    $scope.refreshGrid = function () {
        $('#gridTax').dxDataGrid({
            dataSource: $scope.bankAccounts,
            height: 500,
            //selection: { mode: 'single' },

            editing: {
                editMode: 'batch',
                editEnabled: true
            },
            columns: [
               'BankName',
               'BankNumber',
               'AccountNumber',
               'Owner',
                'Id'
            ]
        });
    };

    $scope.getProductList();

}]);